export const REGULAR_PARAGRAPH_STYLE =
    " text-[13px] md:text-base font-normal  font-Poppins text-Heading_Black  ";
